import React from 'react';
import PropTypes from 'prop-types';
import useSchoolCalendar from './useSchoolCalendar';
import SchoolCalendarView from './SchoolCalendarView';
import { useTranslation } from 'react-i18next';

export default function SchoolCalendarReadPage({ schoolYearStart, contextKey }) {
  const { t: tr } = useTranslation();
  const { loading, data, error, refresh } = useSchoolCalendar({ schoolYearStart, contextKey });
  if (error) {
    return (
      <div className="school-calendar-panel">
        <p role="alert">{error.code === 'SCHEDULE_UPDATING'
          ? tr("calendar:theCalendarIsBeingUpdatedPleaseTryAgainShortly_157")
          : tr("calendar:couldNotLoadTheSchoolCalendarPleaseTryAgain_136")}</p>
        <button type="button" className="manage-teal-button" onClick={refresh}>{tr("manage:tryAgain_183")}</button>
      </div>
    );
  }
  if (!data) return <p role="status">{loading ? tr("calendar:loadingSchoolCalendar_145") : tr("calendar:selectASchoolToViewItsCalendar_158")}</p>;
  return <SchoolCalendarView calendar={data} />;
}
SchoolCalendarReadPage.propTypes = { schoolYearStart: PropTypes.number.isRequired, contextKey: PropTypes.string.isRequired };
